export default {
  base_url: "https://stage-api.norwoodinn.com/",
  // base_url: "https://api.norwoodinns.com/index.php/",
  dummy_token: {
    id: 1,
    token:
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MjYzMzM1NzAsImNoayI6MzY2MDczMzEyLCJ1c2VybmFtZSI6ImFkbWluQGFkbWluLmNvbSIsImlkIjoxLCJpc3MiOiJOb3J3b29kaW5ucy53ZWIifQ.erNX8SOpClCQUs1i9X8PGQRktT0gpZ7KOisgyzhjsAw",
  },
};
